import { nonProdLogger } from "../nonProdLogger"

const COOKIE_NAME = "tc.braze.track"
const COOKIE_EXPIRATION_DAYS = 90
const COOKIE_EXPIRATION_MS = 24 * 60 * 60 * 1000 * COOKIE_EXPIRATION_DAYS
/**
 * Sets a cookie which indicates this user should always be tracked by Braze,
 * regardless of their current article read count.
 *
 * Typically set when a user makes a donation or subscribes to a newsletter.
 */
export function setBrazeTrackingCookie(domain: string) {
  try {
    window.cookieStore.set({
      name: COOKIE_NAME,
      value: "true",
      expires: Date.now() + COOKIE_EXPIRATION_MS,
      domain: removeLeadingPeriod(domain),
    })
  } catch {
    // If the user is on an old browser, it won't support the CookieStore API.
    // If the user has disabled sites being able to set cookies, the call will fail.
    // These aren't important enough errors to log to Bugsnag -- just silence them.
    nonProdLogger("Failed to set Braze tracking cookie")
  }
}

/**
 * Checks to see if the cookie set by the function above is present.
 * If so, returns true.
 */
export async function brazeTrackingCookiePresent(): Promise<boolean> {
  try {
    const cookie = await window.cookieStore.get(COOKIE_NAME)
    return cookie?.value == "true"
  } catch {
    return false
  }
}

// A difference between the older and newer Cookie APIs are that the
// newer ones reject leading periods.
function removeLeadingPeriod(domain: string): string {
  if (domain.startsWith(".")) {
    return domain.slice(1)
  } else {
    return domain
  }
}
